import classNames from "classnames"
import { useTemplate } from "@/lib/helpers/template"
import { getTextEffectClasses } from "@/lib/helpers/utils"
import Block from "@/components/wrappers/block"
import styles from "./heading.module.css"

export default function Heading({ block, settings }) {
  const { classList, noStyling, theme, effect } = block.attrs
  const template = useTemplate()
  const classes = [
    styles.heading,
    theme,
    template,
    classList,
    settings?.innerAlign
  ]

  let width = settings?.width ?? "column"
  let gap = "none"

  if (noStyling) {
    width = gap = null
  }

  return (
    <Block
      block={block}
      width={width}
      gap={gap}
      noStyling={block.attrs.noStyling}
      className={classNames(classes, getTextEffectClasses(effect))}
      innerHtml={block.html}
    />
  )
}
